import { render, staticRenderFns } from "./PartnerBadges.vue?vue&type=template&id=8bc49bb2&scoped=true&"
import script from "./PartnerBadges.vue?vue&type=script&lang=js&"
export * from "./PartnerBadges.vue?vue&type=script&lang=js&"
import style0 from "./PartnerBadges.vue?vue&type=style&index=0&id=8bc49bb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc49bb2",
  null
  
)

export default component.exports